module.exports = __webpack_public_path__ + "img/crown.7588aad3.png";